import { FC, useEffect } from "react";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { Box, Button } from "@material-ui/core";
import useStyles from "../Styles/PopOverStyles";
import { PopoverProps } from "../../interfaces";

const ExplainPopover: FC<PopoverProps> = ({
  id,
  title,
  text,
  next,
  open,
  anchorEl,
  skip,
  handleClose,
}) => {
  const classes = useStyles();

  useEffect(() => {
    document.documentElement.style.overflow = open ? "hidden" : "unset";
  }, [open]);

  return (
    <>
      <Popover
        className={classes.explainPopover}
        id={id}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        onClose={handleClose}
        disableScrollLock={true}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box m={3} className="popover-box">
          <Box className="box-relative">
            <Typography
              variant="h4"
              color="secondary"
              className="font-family-Poppin"
            >
              {title}
            </Typography>
          </Box>
          <Box className="popover-explain-text font-family-Poppin">{text}</Box>
        </Box>
        {next ? (
          <Box marginLeft={3} marginBottom={2} className="flex">
            <Button
              variant="contained"
              className="btn-medium"
              disabled={false}
              color="primary"
              onClick={next}
            >
              Next
            </Button>
            <Button onClick={skip}>skip</Button>
          </Box>
        ) : (
          <Box marginLeft={3} marginBottom={2} className="flex">
            <Button
              variant="contained"
              className="btn-medium"
              disabled={false}
              color="primary"
              onClick={skip}
            >
              Finish
            </Button>
          </Box>
        )}
      </Popover>
    </>
  );
};
export default ExplainPopover;
